// © 2015-2021 WDNA - All Rights Reserved

import api, { AxiosRequestConfig } from '../../../services/api/Connect';

export * from './types';

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function company<T = any>(action: string, id?: string, data?: any, options?: AxiosRequestConfig): Promise<T> | undefined {
  const root: string = 'company';
  switch (action) {
    case 'list':
      return api.post(`${root}/list`, data, options);
    case 'get':
      return id ? api.get(`${root}/get/${id}`, data, options) : undefined;
    case 'set':
      return api.put(`${root}/set`, data, options);
    case 'del':
      return id ? api.delete(`${root}/del/${id}`, data, options) : undefined;
    case 'dashboard':
      return api.put(`${root}/dashboard`, data, options);
    case 'report':
      return id ? api.download(`${root}/report/get/${id}/${data.file}`, data, options) : undefined;
    case 'reports':
      return id ? api.get(`${root}/report/list/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function client<T = any>(action: string, id?: string, data?: any, options?: AxiosRequestConfig): Promise<T> | undefined {
  const root: string = 'client';
  switch (action) {
    case 'list':
      return api.post(`${root}/list`, data, options);
    case 'get':
      return id ? api.get(`${root}/get/${id}`, data, options) : undefined;
    case 'set':
      return api.put(`${root}/set`, data, options);
    case 'del':
      return id ? api.delete(`${root}/del/${id}`, data, options) : undefined;
    case 'sensors_set':
      return id ? api.get(`${root}/sensors/set/${id}`, data, options) : undefined;
    case 'sensors_get':
      return id ? api.get(`${root}/sensors/get/${id}`, data, options) : undefined;
    case 'dashboard':
      return api.post(`${root}/dashboard`, data, options);
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function location<T = any>(action: string, id?: string, data?: any, options?: AxiosRequestConfig): Promise<T> | undefined {
  const root: string = 'location';
  switch (action) {
    case 'list':
      return api.post(`${root}/list`, data, options);
    case 'get':
      return id ? api.get(`${root}/get/${id}`, data, options) : undefined;
    case 'set':
      return api.put(`${root}/set`, data, options);
    case 'del':
      return id ? api.delete(`${root}/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function system<T = any>(action: string, id?: string, data?: any, options?: AxiosRequestConfig): Promise<T> | undefined {
  const root: string = 'system';
  switch (action) {
    case 'log-list':
      return api.get(`${root}/log-list`, data, options);
    case 'log-content':
      return id ? api.get(`${root}/log-content/${id}`, data, options) : undefined;
    case 'proc-list':
      return api.get(`${root}/proc-list`, data, options);
    default:
      return undefined;
  }
}
